/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

// Resizes the media element using http://api.jqueryui.com/resizable
// FUTURE : doesn't work great for YouTube videos, as the mouseover events are lost if you move your cursor out
// from over the handle quickly to hover over the player itself.  Perhaps need to show an overlay during resize?

angular.module('bulbApp.contentEditorModule')
  .directive('bulbResizable', [
    '$',
    'Restangular',
    'BulbAutoSaveService',
    'BulbBrowserService',
    'SerialSaveService',
    'UnitStateStore',
    'CONFIG',
    'CONTENT_EDITOR',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    bulbResizable,
  ]);

function bulbResizable(
  $,
  Restangular,
  BulbAutoSaveService,
  BulbBrowserService,
  SerialSaveService,
  UnitStateStore,
  CONFIG,
  CONTENT_EDITOR,
) {
  return {
    require: ['?^mediumContentEditor', '^contentBlock', '^bulbFrame'],
    link(scope, elem, attrs, ctrls) {
      const isMobile = BulbBrowserService.isMobile();
      const contentEditorCtrl = ctrls[0];
      if (!contentEditorCtrl) {
        return;
      }

      const contentBlockCtrl = ctrls[1];

      // Check if the embedded content-block is that of the custom widget, if so, don't apply the resizable directive
      if (contentBlockCtrl.contentBlock.html) {
        if (contentBlockCtrl.contentBlock.html.indexOf(CONFIG.hosted4hGradingWidgetUrl) > -1) {
          return;
        }
      }

      // Check to see if the content-block is that of an audio block AND the user is using a mobile device, if so,
      // don't allow the resize directive because jwPlayer doesn't allow to dynamically resize it
      if (contentBlockCtrl.contentBlock.blockType === 'AUDIO' && isMobile) {
        return;
      }

      const frameCtrl = ctrls[2];
      const maxWidth = CONFIG.page.content.max.width;

      const attrsOptions = scope.$eval(attrs.bulbResizable);
      const defaultOptions = {
        maxWidth,
      };
      const options = angular.extend({}, defaultOptions, attrsOptions);
      let scale = 0;
      let enabled = false;
      const selectorId = `#${contentBlockCtrl.contentBlock.id}`;
      const $element = $(selectorId);

      // TODO UNDO : how do we undo/redo a resize?

      function updateHandles() {
        if (contentBlockCtrl.selected && frameCtrl.frameState === 'resize') {
          // Need to remove a class that was automatically added by prime-ng:
          $element.find('ui-icon').removeClass('ui-icon');
          let showHandle;
          let hideHandle;
          switch (contentBlockCtrl.alignment) {
            case 'left':
            case 'center':
              showHandle = 'se';
              hideHandle = 'sw';
              break;
            case 'right':
              showHandle = 'sw';
              hideHandle = 'se';
              break;
          }

          // Due to a bug (https://bugs.jqueryui.com/ticket/3423), you cannot dynamically change the
          // resizeHandles after init, so you have to do a workaround.  However, the bug has been fixed, but has
          // not been released yet:
          // Here is where the workaround was found:
          // http://stackoverflow.com/questions/27248747/jquery-ui-change-resizable-handles-after-init
          // contentBlockCtrl.contentElement.resizable('option', { handles: resizeHandles });
          $element.find(`.ui-resizable-${hideHandle}`).hide();
          $element.find(`.ui-resizable-${showHandle}`).show();
        } else {
          $element.find('.ui-resizable-handle').hide();
        }
      }

      function enableDisableResize() {
        if (contentBlockCtrl.selected && frameCtrl.frameState === 'resize') {
          contentBlockCtrl.contentElement.resizable().resizable('enable');
          enabled = true;
          updateHandles();
        } else if (enabled) {
          contentBlockCtrl.contentElement.resizable().resizable('disable');
          enabled = false;
          updateHandles();
        }
      }

      const resizeStart = function resizeStart() {
        contentBlockCtrl.resizing = true;
        elem.addClass('bulb-resizing');
      };

      const resize = function resize(/* event, ui */) {
        contentEditorCtrl.updateToolbar();

        contentBlockCtrl.contentElement.css('left', '');

        // TODO POLISH : swap resize handle icons if min or max size
        // elem.removeClass('max-size');
        // elem.removeClass('min-size');
        // if (Math.round(ui.size.width) === options.maxWidth) {
        //  elem.addClass('max-size');
        // } else if (Math.round(ui.size.width) === 100) {
        //  elem.addClass('min-size');
        // }
      };

      const saveResize = function saveResize(newWidth, newHeight) {
        const patch = {
          width: newWidth,
        };

        const { blockType } = contentBlockCtrl.contentBlock;

        // Embed blocks have height property, other content blocks do not.
        if (blockType === 'EMBED' || blockType === 'ATTACHED_FILE_EMBED') {
          patch.height = newHeight;
        }

        return SerialSaveService.save({
          save: () => Restangular.one('units', contentBlockCtrl.page.unit.id)
            .one(
              CONTENT_EDITOR.BLOCK_PATHS[contentBlockCtrl.contentBlock.blockType],
              contentBlockCtrl.contentBlock.id,
            )
            .patch(patch)
            .then((modifiedContentBlock) => {
              angular.copy(modifiedContentBlock.plain(), contentBlockCtrl.contentBlock);

              // Update share status to reflect that the page has been edited:
              const ShareTransition = UnitStateStore.getShareTransitionEnum();
              UnitStateStore.transitionShareStatus(ShareTransition.EDIT);
            }),
        }).finally(() => {
          contentBlockCtrl.busy = false;
        });
      };

      /**
       * Saves the updated asset sizes.
       * @param event
       * @param ui
       */
      const resizeDone = function resizeDone(event, ui) {
        // TODO POLISH : show inline 'busy' indicator during save
        contentBlockCtrl.busy = true;
        const width = Math.round(ui.size.width * scale);
        const height = Math.round(ui.size.height * scale);
        saveResize(width, height).then(() => {
          contentBlockCtrl.resizing = false;
          elem.removeClass('bulb-resizing');
        });
      };

      // TODO POLISH : resize handles are showing up before the image does.  Perhaps figure out how to delay
      // setting the frame state until the image has finished loading?  Or perhaps delay showing the entire frame.
      frameCtrl.setFrameState('resize');

      scope.$on('frameStateChange', () => {
        enableDisableResize();
      });

      scope.$on('selectionChange', () => {
        if (contentBlockCtrl.selected || enabled) {
          enableDisableResize();
        }
      });

      scope.$watch('contentBlockCtrl.alignment', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          updateHandles();
        }
      });

      function processResizable(resizeOptions) {
        // Make sure max width is never larger than the content width, even if the image width is larger.
        if (resizeOptions.maxWidth > maxWidth) {
          // eslint-disable-next-line no-param-reassign
          resizeOptions.maxWidth = maxWidth;
        }

        const contentWidth = $(contentEditorCtrl.editorElement).width();
        scale = maxWidth / contentWidth;
        let minHeight = 100 / scale; // TODO CLEAN : load this from config
        // eslint-disable-next-line no-param-reassign
        resizeOptions.maxWidth /= scale;

        let aspectRatio = true;
        const { contentBlock } = contentBlockCtrl;

        // Need to check if the current content block is that of an embedded block so that they are not bound
        // by an aspect ratio. This allows the user to control the extra whitespace that is added under the
        // embedded content block.
        if (contentBlock.blockType === 'EMBED' || contentBlock.blockType === 'ATTACHED_FILE_EMBED'
          || contentBlock.blockType === 'AUDIO') {
          aspectRatio = false;
        }

        // The minSize for audio blocks can be less than 100 because that is how jwPlayer sizes audio-only
        // players
        if (contentBlock.blockType === 'AUDIO') {
          minHeight = 40;
        }

        contentBlockCtrl.contentElement.resizable({
          aspectRatio,
          minWidth: (contentBlock.blockType === 'AUDIO') ? (maxWidth / 2) : contentBlock.minWidth,
          minHeight,
          maxHeight: (contentBlock.blockType === 'AUDIO') ? 40 : '',
          maxWidth: resizeOptions.maxWidth,
          // TODO ISSUE : this width and height could
          // change if the image is cropped or the browser is resized, so we need to be able to update these
          // maximums when the image block is updated.
          handles: 'sw, se', // Show both corners, as we will hide the unneeded one manually
          start: resizeStart,
          resize,
          stop: resizeDone,
          disabled: true,
        });
      }

      processResizable(options);

      // Hide handles by default:
      $element.find('.ui-resizable-handle').hide();

      // observe
      attrs.$observe('bulbResizable', (value) => {
        const updatedOptions = scope.$eval(value);
        const resizeOptions = angular.extend({}, defaultOptions, updatedOptions);
        processResizable(resizeOptions);

        const frame = contentBlockCtrl.contentElement.closest('bulb-frame');
        if (frame.length && frame.eq(0).hasClass('selected-block')) {
          contentBlockCtrl.contentElement.click();
        }
      });
    },
  };
}
